import { render, staticRenderFns } from "./CreateSubAdmin.vue?vue&type=template&id=2aca78c0&scoped=true"
import script from "./CreateSubAdmin.vue?vue&type=script&lang=js"
export * from "./CreateSubAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca78c0",
  null
  
)

export default component.exports